import React from "react";
import { Typography, makeStyles } from "@material-ui/core";

type Props = {
  children: string;
  styleProps?: React.CSSProperties;
};

export function StyledHtml(props: Props) {
  const classes = useStyles({});

  return (
    <Typography className={classes.root} style={props.styleProps}>
      <span dangerouslySetInnerHTML={{ __html: props.children }} className="highlighter" />
    </Typography>
  );
}

const useStyles = makeStyles({
  root: {
    wordBreak: "break-word",
    "&>span>p:first-child": {
      marginTop: 0
    },
    "&>span>p:last-child": {
      marginBottom: 0
    }
  }
});
